import { Injectable } from '@angular/core';
import { BlackbaudSsoRouteResponse, TermsOfServiceModelResponse } from '@core/models/auth.model';
import { HttpRestService } from '@core/services/http-rest.service';
import { UserSignInFlowModel, LinkToBbidPayload } from '@core/typings/bbid.typing';
import { APIResponse } from '@yourcause/common';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthResources {

  constructor (
    private httpRestService: HttpRestService
  ) { }

  acknowledgeTermsOfService (termsOfServiceId: number) {
    const endpoint = `/api/TermsOfService/AcknowledgeTermsOfService?termsOfServiceId=${termsOfServiceId}`;

    return this.httpRestService.post(endpoint, {});
  }

  getBlackbaudLoginRoute (): Promise<APIResponse<BlackbaudSsoRouteResponse>> {
    const endpoint = 'api/admin/Sso/SignInUrl';

    return this.httpRestService.get(endpoint);
  }

  getLatestEffectiveTermsOfService (): Promise<APIResponse<TermsOfServiceModelResponse>> {
    const endpoint = 'api/TermsOfService/TermsOfService';

    return this.httpRestService.get(endpoint);
  }

  getUserTermsOfService (): Promise<APIResponse<TermsOfServiceModelResponse>> {
    const endpoint = 'api/TermsOfService/UserTermsOfService';

    return this.httpRestService.get(endpoint);
  }

  getDetermineSignInFlow (email: string) {
    const encodedEmail = encodeURIComponent(email);
    const endpoint = `api/Login/UserSigninFlow?email=${encodedEmail}`;

    return this.httpRestService.Get<APIResponse<UserSignInFlowModel>>(endpoint)
      .pipe(
        map(e => e.data),
        catchError(this.handleError.bind(this))
      );
  }

  verifyBbidLink () {
    const endpoint = 'api/user/VerifyBlackbaudIdLink';

    return this.httpRestService.get(endpoint);
  }

  trackBbidLogin () {
    const endpoint = 'api/user/BlackbaudIdLogin';

    return this.httpRestService.post(endpoint, {});
  }

  linkToBbidAccount (payload: LinkToBbidPayload) {
    const endpoint = 'api/Login/LinkToBlackbaudIdAccount';

    return this.httpRestService.Post<boolean>(endpoint, payload)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  syncInfoFromBBID (firstName: string, lastName: string) {
    const endpoint = 'api/MyAccount/SyncBlackbaudDetail';

    return this.httpRestService.put(endpoint, {
      firstName,
      lastName
    });
  }

  async createNPOAccountForBbid (
    firstName: string,
    lastName: string,
    email: string,
    languageCulture: string
  ) {
    const endpoint = 'api/user/CreateUserForBlackbaudId';

    return this.httpRestService.post(endpoint, {
      email,
      firstName,
      lastName,
      languageCulture
    });
  }

  private handleError (error: any): Observable<never> {
      return throwError(() => error);
    }
}
